export enum ThresholdOfResponsiveness { 
    QuiteReponsive = 1,
    LowResponsive=3
}